/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodeFork = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 2c2.206 0 4 1.794 4 4a4.007 4.007 0 0 1-3 3.873v4.254c.39.1.757.258 1.091.464l4.49-3.516A3.977 3.977 0 0 1 13 9c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4c-.728 0-1.41-.195-1.999-.536l-4.531 3.547c.337.586.53 1.265.53 1.989 0 2.206-1.794 4-4 4s-4-1.794-4-4a4.007 4.007 0 0 1 3-3.874V9.874A4.007 4.007 0 0 1 3 6c0-2.206 1.794-4 4-4zm0 14c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm10-9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM7 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCodeFork as CodeFork };
